export default __webpack_public_path__ + "static/media/T3-output1.8891f093.png";